
import { requestILink } from '@/utils/request';
import { EntitiesDataWrapper } from '@/types/request';
import {
  GET_UNREAD_MSG_COUNT,
  GET_INBOX_MSGS,
} from './cmd';
import { MessageItem } from '@/types/message';

export const getUnreadMsgCount = () => requestILink<{ unreadCount: number }>({ cmd: GET_UNREAD_MSG_COUNT });
export const getMessages = ({
  start = 0,
  length = 10,
}: {
  start: number;
  length?: number;
}) => requestILink<EntitiesDataWrapper<MessageItem>>({ cmd: GET_INBOX_MSGS, start, length });
